// extracted by mini-css-extract-plugin
export default {"app-container":"Home_app-container__c6d6i","title":"Home_title__zljM+","app-img":"Home_app-img__biX+A"};